import { extend } from '../utils/objects';
/**
 * Adds functions to given component.
 * These functions are supposed to be used for component specific logic,
 * e.g. defining an inner-state or helping sorting its children.
 * @abstract
 */
export function extendComponent(customPrototype, definition) {
    var functions = definition.functions || {};
    extend(customPrototype, functions);
}
//# sourceMappingURL=FunctionHandling.js.map